<template>
<billing-dialog aria-labelledby="pbx-plan-detail-id" class="pbx-detail-dialog" :visible.sync="visible" show-close @close="handleCancel" width="510px" :before-close="trackingClose" @back-event="visible = false">
  <span id="pbx-plan-detail-id" class="opc_hidden_element">Zoom Phone dialog</span>
  <!--header-->
  <img :src="logo" alt="" class="pbx-detail-dialog__logo">
  <h1 class="pbx-detail-dialog__title">{{ callingPlanName }}</h1>
  <div class="pbx-detail-dialog__price">
    <Price class="pbx-detail-dialog__price-item" :currency="currencySymbol" :price="monthlyPrice" :unit="$t('billing.common.per_billing_cycle_user.monthly')" />
    <Price class="pbx-detail-dialog__price-item" :currency="currencySymbol" :price="annualPrice" :unit="$t('billing.common.per_billing_cycle_user.annual')" />
  </div>
  <FeatureULForUnlimited v-if="subType === 'UC'"  />
  <FeatureULForMetered v-else />
  <zm-button data-testid="checkout-button-179" type="primary" ghost class="pbx-detail-dialog__confirm-btn" @click="handleSure">{{ $t('billing.pbx.plan_details.view_more') }}</zm-button>
</billing-dialog>
</template>

<script type="text/jsx">
import ZoomPhoneIcon from '@/assets/plans/logo_zoom_phone.svg';
import Price from '@/components/price.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import { mapState } from 'vuex';
import { BILLING_CYCLE } from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import {getCurrency, getCurrencySymbol} from "@/utils/currency";
import { computedPbxCallingPlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import BillingDialog from '@/components/billing-dialog.vue';

const FeatureULForUnlimited = {
  render() {
    return (
      <ul class="pbx-detail-dialog__feature" aria-label="Unlimited Calling Plan feature list">
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{ this.$t('marketing.new_pricing.phone.unlimited_plan.item2') }</li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{ this.$t('marketing.new_pricing.phone.metered_plan.item1') }</li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">
          {this.$t('marketing.new_pricing.phone.item.sms')}
          <zm-tooltip
            placement="top"
            aria-label="Learn more about Domestic SMS & MMS"
            content={this.$t('marketing.new_pricing.phone.item.sms.tip')}
          >
            <zm-button data-testid="checkout-button-180" type="icon" icon="zm-icon-info-outline main-color-icon" ghost size="mini"></zm-button>
          </zm-tooltip>
        </li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{this.$t('marketing.new_pricing.phone.metered_plan.item3')}</li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{this.$t('marketing.new_pricing.common.one_management_portal')}
          <zm-tooltip
            placement="top"
            aria-label="Learn more about One management portal"
            content={this.$t('marketing.new_pricing.common.one_management_portal_tooltip')}
          >
            <zm-button data-testid="checkout-button-181" type="icon" icon="zm-icon-info-outline main-color-icon" ghost size="mini"></zm-button>
          </zm-tooltip>
        </li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{this.$t('marketing.new_pricing.phone.domestic_plan.item5')}
          <zm-tooltip
            placement="top"
            aria-label="Learn more about countries/territory"
            content={this.$t('marketing.new_pricing.phone.domestic_plan.item5.tip')}
          >
            <zm-button data-testid="checkout-button-182" type="icon" icon="zm-icon-info-outline main-color-icon" ghost size="mini"></zm-button>
          </zm-tooltip>
        </li>
      </ul>
    );
  },
};

const FeatureULForMetered = {
  render() {
    return (
      <ul class="pbx-detail-dialog__feature" aria-label="Metered Calling Plan feature list">
        <li class="pbx-detail-dialog__feature-item" tabindex="0" domPropsInnerHTML={this.$t('marketing.new_pricing.phone.metered_plan.new.item1')} />
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{this.$t('marketing.new_pricing.phone.metered_plan.item1')}</li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">
          {this.$t('marketing.new_pricing.phone.item.sms')}
          <zm-tooltip
            placement="top"
            aria-label="Learn more about Domestic SMS & MMS"
            content={this.$t('marketing.new_pricing.phone.item.sms.tip')}
          >
            <zm-button data-testid="checkout-button-183" type="icon" icon="zm-icon-info-outline main-color-icon" ghost size="mini"></zm-button>
          </zm-tooltip>
        </li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{this.$t('marketing.new_pricing.phone.metered_plan.item3')}</li>
        <li class="pbx-detail-dialog__feature-item" tabindex="0">{this.$t('marketing.new_pricing.common.one_management_portal')}

          <zm-tooltip
            placement="top"
            aria-label="Learn more about One management portal"
            content={this.$t('marketing.new_pricing.common.one_management_portal_tooltip')}
          >
            <zm-button data-testid="checkout-button-184" type="icon" icon="zm-icon-info-outline main-color-icon" ghost size="mini"></zm-button>
          </zm-tooltip>
        </li>
      </ul>
    )
  },
}

export default {
  name: 'CallingPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    Price,
    FeatureULForUnlimited,
    FeatureULForMetered,
    BillingDialog,
  },
  props: {
    subType: String,
  },
  data() {
    return {
      visible: false,
      logo: ZoomPhoneIcon,
      currencySymbol: getCurrencySymbol(getCurrency()),
      essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
    };
  },
  methods: {
    handleOpen() {
      this.$tracking.buyInteraction('product details', `zoom phone plan details - ${this.typeName} - impression`);
    },
    handleSure() {
      this.$tracking.buyInteraction('product details', `zoom phone plan details - ${this.typeName} - view more`);
    },
    trackingClose(close) {
      this.$tracking.buyInteraction('product details', `zoom phone plan details - ${this.typeName} - exit`);
      close();
    }
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    annualPriceNum () {
      let annualPlan = computedPbxCallingPlans(this.planMapFlat).find(plan => (
        plan.sub_type === this.subType &&
        plan.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
      if (annualPlan) {
        return annualPlan.amount;
      }
      return 0;
    },
    annualPrice () {
      return (this.annualPriceNum / 100).toFixed(2);
    },
    monthlyPriceNum () {
      let monthlyPlan = computedPbxCallingPlans(this.planMapFlat).find(plan => (
        plan.sub_type === this.subType &&
        plan.billing_cycle === BILLING_CYCLE.MONTHLY
      ));
      if (monthlyPlan) {
        return monthlyPlan.amount;
      }
      return 0;
    },
    monthlyPrice () {
      return (this.monthlyPriceNum / 100).toFixed(2);
    },
    callingPlanName() {
      switch(this.subType) {
        case PBX_SUB_TYPES.UNLIMITED:
          return this.$t('billing.pbx.detail_dialog.unlimited.plan_name');
        case PBX_SUB_TYPES.METERED:
          return this.$t('billing.pbx.detail_dialog.metered.plan_name');
        default:
          return '';
      }
    },
    typeName() {
      return this.subType === PBX_SUB_TYPES.METERED ? 'metered' : 'unlimited regional';
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.pbx-detail-dialog {
  .zm-dialog {
    padding: 70px 60px;
    width: fit-content;
    max-width: calc(100vw - 200px);
  }
  .main-color-icon {
    color: $theme-color;
  }
  &__logo {
    width: 91px;
    height: 16px;
    object-fit: contain;
    margin-bottom: 4px;
  }
  &__title {
    font-family: $happy-display;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 120%;
    color: #666487;
    margin-bottom: 16px;
  }
  &__price {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 17px;
    &-item {
      flex: 1;
      padding-right: 24px;
      padding-left: 0;
      display: flex;
      align-items: flex-start;
      .price__currency {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__int {
        font-family: $happy-display;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 48px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__decimal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: #00053D;
        margin-right: 2px;
      }
      .price__unit {
        font-style: normal;
        font-weight: 450;
        font-size: 16px;
        line-height: 38px;
        color: #00053D;
        align-self: flex-end;
      }
      &+& {
        padding-right: 0;
        padding-left: 24px;
        border-left: 2px solid #B8B8C4;
      }
    }

  }
  &__feature {
    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      color: #00053D;
    }
    &-item {
      position: relative;
      padding-left: 20px;
      margin-bottom: 16px;
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #00053D;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        background-image: url('../../../../assets/Vector.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 16px;
        height: 21px;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
  &__link.zm-button--link {
    font-style: normal;
    font-weight: 450;
    font-size: 12px;
    line-height: 150%;
    padding: 0;
  }
  &__confirm-btn {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
    color: #0B5CFF;
    margin-top: 32px;
  }
  &__tips {
    margin: 0;
    margin-top: 16px;
    padding: 8px 12px;
    background: #F2F2F4;
    border-radius: 8px;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
  }
}
</style>
